import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import { HeroImage } from './HeroImage/HeroImage';
import { Container } from "react-bootstrap";
import HelpMeDecide from './HelpMeDecide/HelpMeDecide';
import GettingCoveredSteps from './GettingCoveredSteps/GettingCoveredSteps';
import CostlyMistakes from './CostlyMistakes/CostlyMistakes';
import Carriers from './Carriers/Carriers';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import BeforeFooter from '../BeforeFooter/BeforeFooter';
import Marketing from "./Marketing/Marketing";
import SvgIcon from '@material-ui/core/SvgIcon';
import PolicyReviewIcon from '../../icons/policyReview.svg';
import CalculatorIcon from '../../icons/calculator.svg';
import './Home.scss';

const Home = (props) => {

  const [account] = useState(getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY))
  const [showNeedsAnalysis, setShowNeedsAnalysis] = useState(false);
  const [enablePolicyReview, setEnablePolicyReview] = useState(false);

  useEffect(() => {
    window.scrollTo(0,0);
    if (!account || !account.account) {
      return;
    }

    if (account.account.redirectUrl) {
      props.history.push(account.account.redirectUrl);
    }

    setShowNeedsAnalysis(account.account.enableNeedsAnalysis != null ? account.account.enableNeedsAnalysis : true);
    setEnablePolicyReview(account.account.enablePolicyReview != null ? account.account.enablePolicyReview : false);
  }, [account])

  return (
    <Container fluid className="home">
      {account && account.account &&
        <Fragment>
          <Helmet>
            <title>Insurance from {account.account.accountName}</title>
          </Helmet>

          <HeroImage cardContent={props.productInfo} />
          {showNeedsAnalysis &&
            <HelpMeDecide
              title='How much life insurance do I need?'
              subTitle='Life Insurance Needs Analysis'
              icon={<SvgIcon component={CalculatorIcon} className="need-icons" color="primary" />}
            />
          }
          {enablePolicyReview &&
            <HelpMeDecide
              enablePolicyReview={enablePolicyReview}
              title='Do I have the right coverage?'
              subTitle='Life Insurance Policy Review'
              icon={<SvgIcon component={PolicyReviewIcon} className="need-icons" color="primary" />}
            />
          }
          <Marketing testimonials={(account.account.testimonials)} />
          <GettingCoveredSteps />
          <CostlyMistakes />
          <Carriers />
          <BeforeFooter title="Let's get some life insurance." href="#product-tiles" />
        </Fragment>
      }

    </Container>
  );
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js